import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

import Htmlify from "~/chat/vue/misc/ChatHtmlify.vue";
import {useTabContentProps} from "~/chat/vue/widget/tabs/useTabContent";


const __default__ = {
    name: "HtmlContent"
}

export default /*@__PURE__*/_defineComponent({
  ...__default__,
  props: {
    ...useTabContentProps()
},
  setup(__props) {

let props = __props;

return (_ctx: any,_cache: any) => {
  return (_ctx.tab.content.html)
    ? (_openBlock(), _createBlock(Htmlify, {
        key: 0,
        value: _ctx.tab.content.html,
        escape: false
      }, null, 8, ["value"]))
    : _createCommentVNode("", true)
}
}

})